import React, { useState } from 'react'
import { BsInfoLg } from 'react-icons/bs'
import { GrClose } from 'react-icons/gr'
import shallow from 'zustand/shallow';
import Modal from "react-bootstrap/Modal";
import { MenuItem } from 'react-pro-sidebar'
import constants from "../../utils/constants"
import { useUserStore } from "../../stores";
import "./styles.css"
const HELP_VIDEOS = constants().HELP_VIDEOS;
const HelpVideo = ({ collapseSidebar }) => {
    const user = useUserStore((state) => state.data, shallow);
    const [open, setOpen] = useState(false);
    const url = HELP_VIDEOS[user.role];
    console.log(url)
    React.useEffect(() => {
        if (open) {
            window.Tawk_API.hideWidget();
        }
        return () => {
            window.Tawk_API.showWidget();
        }
    }, [open])

    return (
        // style={{ position: "absolute", right: "1.3rem", top: "1.7rem", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}
        <>
            <Modal
                show={open}
                onHide={() => setOpen(false)}
                onExit={() => setOpen(false)}
                className="modalHelpVideo"
                fullscreen={true}
                backdrop={'static'}
            >
                <Modal.Header className="modalheader" style={{ border: "none", color: "white" }}>
                    <Modal.Title className="modaltitle">
                        <h3 className="w-100 text-center">Help Guide</h3>
                        <div className='btn btn-danger' onClick={() => setOpen(false)}><GrClose style={{ color: 'white', fontSize: "1.35rem" }} /></div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="modalBody" style={{ paddingBottom: "3%" }}>
                    <iframe id="helpiframemodal" width="96%" height="auto" src={url} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </Modal.Body>
            </Modal>
            <MenuItem className={open ? (!collapseSidebar ? "menuItemLight" : "collapsedMenuItemLight") : ""} iconShape="circle" style={{ fontWeight: "700", marginTop: "1.5rem" }} onClick={() => setOpen(true)} icon={<BsInfoLg />}>
                <h5 style={{ fontSize: "1.2rem", margin: "0 0 0 0.3rem", fontWeight: 700 }}>Tour</h5>
            </MenuItem>
        </>
    )
}

export default HelpVideo